import { addYears, startOfMonth } from "date-fns";
import { GOAL_DEADLINE_MAX_YEARS } from "web_myplann/Goals/constants";

export const getMaxGoalDueDate = (now: Date = new Date()): Date =>
	startOfMonth(addYears(now, GOAL_DEADLINE_MAX_YEARS));
